export default function createTabs(containerSelector = '.js-tabs-container', debug = false) {
  let containers = document.querySelectorAll(containerSelector);
  if (! containers.length) return;

  window.addEventListener('load', event => {
    init();
  });

  async function init() {
    const { default: Tabs } = await import('../classes/Tabs');

    containers.forEach(container => {
      new Tabs(container, true);
    });
  }
}
